(function () {
  const script = document.currentScript;
  const apiBase = (script && script.dataset.apiBase) || 'https://api.teeswipe.app/v1';
  const actorKey = 'bazzai_anonymous_user_id';
  const cacheKey = 'bazzai_catalog_reactions_v1';
  const states = new Map();
  const catalog = new Map();
  let actorID = '';

  function validUUID(value) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value || '');
  }

  function getActorID() {
    let value = localStorage.getItem(actorKey) || '';
    if (!validUUID(value)) {
      value = crypto.randomUUID();
      localStorage.setItem(actorKey, value);
    }
    return value;
  }

  function loadCache() {
    try {
      const cached = JSON.parse(localStorage.getItem(cacheKey) || '{}');
      Object.entries(cached).forEach(([handle, reaction]) => {
        if (reaction === 'like' || reaction === 'dislike') states.set(handle, reaction);
      });
    } catch (_) {
      localStorage.removeItem(cacheKey);
    }
  }

  function saveCache() {
    localStorage.setItem(cacheKey, JSON.stringify(Object.fromEntries(states)));
  }

  async function request(path, options) {
    const response = await fetch(`${apiBase}${path}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'X-Anonymous-User-ID': actorID,
        ...(options && options.headers),
      },
    });
    if (!response.ok && response.status !== 204) throw new Error(`reaction request failed: ${response.status}`);
    return response.status === 204 ? null : response.json();
  }

  function rootsFor(handle) {
    return Array.from(document.querySelectorAll('[data-reaction-root]')).filter(
      (root) => root.dataset.designHandle === handle,
    );
  }

  function renderHandle(handle) {
    const current = states.get(handle) || '';
    rootsFor(handle).forEach((root) => {
      root.querySelectorAll('[data-reaction]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.reaction === current));
      });
    });
  }

  function renderCounts() {
    const count = Array.from(states.values()).filter((reaction) => reaction === 'like').length;
    document.querySelectorAll('[data-likes-count]').forEach((node) => {
      node.textContent = String(count);
    });
  }

  function renderLikedView() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('liked') !== '1') return;
    document.querySelectorAll('[data-dynamic-liked-card]').forEach((card) => card.remove());
    const cards = Array.from(document.querySelectorAll('[data-design-card]'));
    const staticHandles = new Set(cards.map((card) => card.dataset.designHandle));
    let shown = 0;
    cards.forEach((card) => {
      const liked = states.get(card.dataset.designHandle) === 'like';
      card.hidden = !liked;
      if (liked) shown += 1;
    });
    const grid = document.querySelector('.bz-designs-grid');
    if (grid) {
      catalog.forEach((row, handle) => {
        if (states.get(handle) !== 'like' || staticHandles.has(handle)) return;
        grid.appendChild(buildLikedCard(row));
        renderHandle(handle);
        shown += 1;
      });
    }
    let empty = document.querySelector('[data-likes-empty]');
    if (!shown && grid && !empty) {
      empty = document.createElement('div');
      empty.className = 'bazzai-likes-empty';
      empty.dataset.likesEmpty = '';
      empty.innerHTML = '<strong>No likes yet.</strong><br>Tap Like on any design or product and it will be waiting here.';
      grid.appendChild(empty);
    } else if (shown && empty) {
      empty.remove();
    }
  }

  function buildLikedCard(row) {
    const article = document.createElement('article');
    article.className = 'bz-design-card';
    article.dataset.dynamicLikedCard = '';
    article.dataset.designHandle = row.designHandle;

    const link = document.createElement('a');
    link.className = 'bz-design-card__link';
    link.href = row.catalogHandle
      ? `/pages/designs/${encodeURIComponent(row.catalogHandle)}`
      : `/search?q=${encodeURIComponent(`tag:${row.designHandle}`)}&type=product`;
    const media = document.createElement('span');
    media.className = 'bz-design-card__media';
    if (row.imageUrl) {
      const image = document.createElement('img');
      image.src = row.imageUrl;
      image.alt = row.title || 'Liked design';
      image.loading = 'lazy';
      image.width = 400;
      image.height = 480;
      media.appendChild(image);
    }
    const title = document.createElement('span');
    title.className = 'bz-design-card__title';
    title.textContent = row.title || 'Liked design';
    const source = document.createElement('span');
    source.className = 'bz-design-card__artist';
    source.textContent = row.catalogHandle ? 'Original Bazzai artwork' : 'Shop this design';
    link.append(media, title, source);

    const reactions = document.createElement('div');
    reactions.className = 'bazzai-reactions';
    reactions.dataset.reactionRoot = '';
    reactions.dataset.designHandle = row.designHandle;
    reactions.setAttribute('aria-label', 'Rate this design');
    reactions.innerHTML = '<button class="bazzai-reactions__button" type="button" data-reaction="like" aria-pressed="false"><span aria-hidden="true">♡</span><span>Like</span></button><button class="bazzai-reactions__button" type="button" data-reaction="dislike" aria-pressed="false"><span aria-hidden="true">×</span><span>Not for me</span></button><span class="visually-hidden" data-reaction-status aria-live="polite"></span>';
    article.append(link, reactions);
    return article;
  }

  function renderAll() {
    document.querySelectorAll('[data-reaction-root]').forEach((root) => renderHandle(root.dataset.designHandle));
    renderCounts();
    renderLikedView();
  }

  async function syncFromServer() {
    const payload = await request('/catalog/reactions/', { method: 'GET' });
    states.clear();
    catalog.clear();
    (payload.reactions || []).forEach((row) => {
      states.set(row.designHandle, row.reaction);
      catalog.set(row.designHandle, row);
    });
    saveCache();
    renderAll();
  }

  async function onReactionClick(button) {
    const root = button.closest('[data-reaction-root]');
    if (!root) return;
    const handle = root.dataset.designHandle;
    const requested = button.dataset.reaction;
    const previous = states.get(handle) || '';
    const next = previous === requested ? '' : requested;
    rootsFor(handle).forEach((item) => item.querySelectorAll('button').forEach((control) => { control.disabled = true; }));
    if (next) states.set(handle, next); else states.delete(handle);
    saveCache();
    renderAll();

    try {
      if (next) {
        const row = await request(`/catalog/reactions/${encodeURIComponent(handle)}`, {
          method: 'POST',
          body: JSON.stringify({ reaction: next }),
        });
        if (row) catalog.set(row.designHandle, row);
      } else {
        await request(`/catalog/reactions/${encodeURIComponent(handle)}`, { method: 'DELETE' });
        catalog.delete(handle);
      }
      rootsFor(handle).forEach((item) => {
        const status = item.querySelector('[data-reaction-status]');
        if (status) status.textContent = next === 'like' ? 'Saved to Your Likes' : next === 'dislike' ? 'Marked not for me' : 'Reaction removed';
      });
    } catch (_) {
      if (previous) states.set(handle, previous); else states.delete(handle);
      saveCache();
      renderAll();
      rootsFor(handle).forEach((item) => {
        const status = item.querySelector('[data-reaction-status]');
        if (status) status.textContent = 'Could not save. Please try again.';
      });
    } finally {
      rootsFor(handle).forEach((item) => item.querySelectorAll('button').forEach((control) => { control.disabled = false; }));
    }
  }

  function init() {
    if (!window.crypto || !window.crypto.randomUUID) return;
    actorID = getActorID();
    loadCache();
    renderAll();
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-reaction]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      onReactionClick(button);
    });
    syncFromServer().catch(() => {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
